/**
 * MOCK question-topic list (ask-a-question-faq.md §2.1: "Category is reused as the topic
 * taxonomy" — Category gains the same Kind field; concern categories and question topics are the
 * SAME entity type, filtered by Kind). Mirrors categories.ts's shape.
 *
 * USE_MOCKS-fallback only — every live-aware surface reads topics from the real Kind=question
 * Category entities instead: resident surfaces (AskPage/FaqPage) via ThemeProvider's
 * `questionTopics` (fed by GET /api/public/embed-config, server-split by Kind); staff surfaces
 * (QuestionDetailPage's publish composer, FaqAdmin's topic select, CategoriesAdmin's Question tab)
 * via `listQuestionTopics()` (GET /api/admin/categories, filtered to Kind=question). This mock list
 * is the seed data mockDb.ts's CATEGORIES spreads in for USE_MOCKS=true, and the last-resort
 * fallback if a live fetch returns an empty list (a brand-new tenant with no topics configured
 * yet) — never imported directly by a resident/staff page anymore.
 */
export interface QuestionTopic {
  id: string;
  label: string;
}

export const MOCK_QUESTION_TOPICS: QuestionTopic[] = [
  { id: "utilities", label: "Utilities (water, trash, sewer)" },
  { id: "permits", label: "Permits & licensing" },
  { id: "meetings", label: "Council meetings & agendas" },
  { id: "taxes", label: "Taxes & payments" },
  { id: "general", label: "Something else" },
];
